import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle<{ $zIndex: number }>`
  .tox.tox-tinymce-aux {
    z-index: ${({ $zIndex }) => $zIndex};
  }
`
